(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("Cw_office_sdk", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["Cw_office_sdk"] = factory(require("vue"));
	else
		root["Cw_office_sdk"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 